import PropTypes from 'prop-types';
import React from 'react';

import { Card } from '../../Atoms/Card';
import { AlertSeverity } from '../../Molecules/Alert';

const Messages = ({ title: cardTitle, data, dateFormatter, ...props }) => {
  return (
    <Card title={cardTitle} {...props}>
      <div>
        {data?.map(({ id, title, severity, description, occurredAt }) => (
          <div className="mb-3" key={id}>
            <AlertSeverity severity={severity} />
            <div className="text-danger">
              <h5>{title}</h5>
              <p>{description}</p>
              <p>{dateFormatter ? dateFormatter(occurredAt) : occurredAt}</p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

Messages.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      occurredAt: PropTypes.string.isRequired,
      severity: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
  dateFormatter: PropTypes.func,
};

export default Messages;
